import type { TFlowKind } from '@besuites/auth/flow';

const PURPOSES: Partial<Record<TFlowKind, string>> = {
    'sign-in': 'login',
    'sign-up': 'verify_email',
    recovery: 'recovery',
    'verify-contact': 'verify_email',
    'step-up': 'step_up',
};

const valuesOf = (step: unknown): string[] => {
    const input = (step as { input?: { purpose?: { values?: unknown } } } | null)?.input;
    const values = input?.purpose?.values;
    return Array.isArray(values) ? values.filter((value): value is string => typeof value === 'string') : [];
};

export default function flowPurposeOf(kind: TFlowKind, step: unknown): string | null {
    const wanted = PURPOSES[kind] ?? null;
    const values = valuesOf(step);
    if (values.length === 0) return wanted;
    if (wanted !== null && values.includes(wanted)) return wanted;
    return values[0] ?? null;
}
